<template>
<div>
  <div v-if="latestbuilds.length != 0 && latestbuildsrmx1971.length != 0 && latestbuildsr5x.length != 0 && latestbuildsEVEN.length != 0">
    <div class="header1">
      <h3>Device's Supported By Us</h3>
    </div>
    <div class="devices">
      <v-container>
        <v-row justify="space-around">
          <v-card width="350" dark class="card">
            <v-img
              src="../assets/RMX1971.jpg"
              style="margin-top:3%;cursor:pointer"
              @click="goto_rmx1971()"
            >
            </v-img>

            <v-card-text>
              <div class="font-weight-bold ml-8 mb-2">
                Realme 5 Pro
              </div>

              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                  v-for="latestbuild in latestbuildsrmx1971"
                  :key="latestbuild"
                  small
                >
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 12'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android12/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 11'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android11/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type != 'rom'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                </v-timeline-item>
              </v-timeline>
              <v-btn outlined rounded text href="/RMX1971" class="foota">Explore More</v-btn>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container>
        <v-row justify="space-around">
          <v-card width="350" dark class="card">
            <v-img
              src="../assets/RMX1911.jpg"
              style="margin-top:3%;cursor:pointer;"
              @click="goto_r5x()"
            >
            </v-img>

            <v-card-text>
              <div class="font-weight-bold ml-8 mb-2">
                Realme 5 Series
              </div>

              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                  v-for="latestbuild in latestbuildsr5x"
                  :key="latestbuild"
                  small
                >
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 12'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android12/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 11'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android11/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type != 'rom'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                </v-timeline-item>
              </v-timeline>
              <v-btn outlined rounded text href="/r5x" class="foota">Explore More</v-btn>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container>
        <v-row justify="space-around">
          <v-card width="350" dark class="card">
            <v-img
              src="../assets/EVEN.png"
              style="margin-top:3%;cursor:pointer;"
              @click="goto_even()"
            >
            </v-img>

            <v-card-text>
              <div class="font-weight-bold ml-8 mb-2">
                Realme C25 Series
              </div>

              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                  v-for="latestbuild in latestbuildsEVEN"
                  :key="latestbuild"
                  small
                >
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 12'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android12/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 11'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/android11/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                  <a v-if="latestbuild.type != 'rom'"
                     :href="latestbuild.device+'/'+latestbuild.maintainer+'/'+latestbuild.name">
                    <div class="font-weight-normal">
                      <strong>{{ latestbuild.name }}</strong> @ {{ latestbuild.build_date }}
                    </div>
                    <div>BY : {{ latestbuild.maintainer }}</div>
                  </a>
                </v-timeline-item>
              </v-timeline>
              <v-btn outlined rounded text href="/EVEN" class="foota">Explore More</v-btn>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </div>
    <div class="header1">
      <h4>Latest Builds</h4>
    </div>
    <div v-if="latestbuilds" class="latestbuilds">
      <div v-for="latestbuild in latestbuilds" :key="latestbuild" class="latestbuild">
        <v-card
          class="mx-auto build"
          max-width="400"
          min-height="275"
          outlined
          dark
          @click="goto_page(latestbuild.type,latestbuild.version,latestbuild.device,latestbuild.maintainer,latestbuild.name)"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h5">
                {{ latestbuild.name }}
              </v-list-item-title>
              <v-list-item-subtitle><strong>Device : </strong> 
                <i v-if="latestbuild.device == 'RMX1971'">Realme 5 Pro</i>
                <i v-if="latestbuild.device == 'r5x'">Realme 5 Series</i>
                <i v-if="latestbuild.device == 'EVEN'">Realme C25 Series</i>
              </v-list-item-subtitle>
              <v-list-item-subtitle><strong>By : </strong>  
                <i>{{ latestbuild.maintainer }}</i>
              </v-list-item-subtitle>
              <v-list-item-subtitle><strong>Build Date : </strong> 
                <i>{{ latestbuild.build_date }}</i>
              </v-list-item-subtitle>
              <v-list-item-subtitle><strong>Version : </strong> 
                <i>{{ latestbuild.version }}</i>
              </v-list-item-subtitle>
              <v-list-item-subtitle><strong>Download : </strong> 
                <i><a :href="latestbuild.download">{{ latestbuild.name }}</a></i>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
              tile
              size="80"
              color="grey"
            ><img :src="latestbuild.logo"></v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn
              outlined
              rounded
              text
              class="foota"
              v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 12'"
              :href="latestbuild.device+'/'+latestbuild.maintainer+'/android12/'+latestbuild.name"
            >
              Explore More
            </v-btn>
            <v-btn
              outlined
              rounded
              text
              class="foota"
              v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 11'"
              :href="latestbuild.device+'/'+latestbuild.maintainer+'/android11/'+latestbuild.name"
            >
              Explore More
            </v-btn>
            <v-btn
              outlined
              rounded
              text
              class="foota"
              v-if="latestbuild.type != 'rom'"
              :href="latestbuild.device+'/'+latestbuild.maintainer+'/'+latestbuild.name"
            >
              Explore More
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
  <div v-if="loadingdata && latestbuilds.length == 0 || latestbuildsrmx1971.length == 0 || latestbuildsr5x.length == 0 || latestbuildsEVEN.length == 0" class="header1">
    <v-progress-circular
      :rotate="180"
      :size="100"
      :width="15"
      :value="value"
      color="blue"
    >
      {{ value }}
    </v-progress-circular>
  </div>
  <div v-if="nodata" class="header1">
    <img src="../assets/404.png" alt="404(Not Found)">
      <h1>404</h1>
      <p>No Data Found</p>
  </div>
</div>
</template>

<script>  
import axios from 'axios';

export default {
    name: 'Home',
    components: {

    },
    data: () => ({
      latestbuilds: [],
      latestbuildsrmx1971 : [],
      latestbuildsr5x : [],
      latestbuildsEVEN : [],
      loadingdata: false,
      nodata: false,
      interval: {},
      value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
      this.getlatestBuilds();
      this.getlatestBuildsForDeviceRMX1971();
      this.getlatestBuildsForDevicer5x();
      this.getlatestBuildsForDeviceEVEN();
    },

    methods: {
      getlatestBuilds() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getLatestBuilds`,
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
          this.latestbuilds = response.data.message;
          if (this.latestbuilds) {
              this.loadingdata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 2000);
              setTimeout(() => { this.nodata = true; }, 2000);
          }
        })
      },
      getlatestBuildsForDeviceRMX1971() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getLatestBuildsForDevice?device=RMX1971`,
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
          this.latestbuildsrmx1971 = response.data.message;
          if (this.latestbuildsrmx1971) {
              this.loadingdata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 2000);
              setTimeout(() => { this.nodata = true; }, 2000);
          }
        })
      },
      getlatestBuildsForDevicer5x() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getLatestBuildsForDevice?device=r5x`,
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
          this.latestbuildsr5x = response.data.message;
          if (this.latestbuildsr5x) {
              this.loadingdata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 2000);
              setTimeout(() => { this.nodata = true; }, 2000);
          }
        })
      },
      getlatestBuildsForDeviceEVEN() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getLatestBuildsForDevice?device=EVEN`,
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
          this.latestbuildsEVEN = response.data.message;
          if (this.latestbuildsEVEN) {
              this.loadingdata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 2000);
              setTimeout(() => { this.nodata = true; }, 2000);
          }
        })
      },
      goto_rmx1971() {
        window.location.href = '/RMX1971'
      },
      goto_r5x() {
        window.location.href = '/r5x'
      },
      goto_even() {
        window.location.href = '/EVEN'
      },
      goto_page(type,version,device,maintainer,name) {
        if (type == 'rom' && version == 'Android 12') {
          window.location.href = device+'/'+maintainer+'/android12/'+name;
        } else if (type == 'rom' && version == 'Android 11') {
          window.location.href = device+'/'+maintainer+'/android11/'+name;
        } else if (type != 'rom') {
          window.location.href = device+'/'+maintainer+'/'+name
        }
      }
    },
  }
</script>
<style scoped>
.header1 {
  margin-top:8%;
  text-align: center;
}
.devices {
  margin-top:2%;
  margin-bottom: 2%;
  display:flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}
.card {
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
  margin: 1%
}
.latestbuilds {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 88%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom :2%;
}
.latestbuild {
  margin : 2%;
}
.build {
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.v-timeline-item__body a {
  color:whitesmoke;
  text-decoration : none;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.foota:hover {
  text-decoration: none;
}
@media (max-width: 1000px) {
  .header1 {
    margin-top: 10%;
  }
  .devices {
    display: block;
  }
}
@media (max-width: 550px) {
  .header1 {
    margin-top: 18%;
  }
  .latestbuilds {
    margin-bottom : 12%;
  }
}

</style>